/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Invite_FailedInputs */

const en_team_invite_failed = /** @type {(inputs: Team_Invite_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to send invite.`)
};

const es_team_invite_failed = /** @type {(inputs: Team_Invite_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al enviar la invitación.`)
};

const fr_team_invite_failed = /** @type {(inputs: Team_Invite_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de l'envoi de l'invitation.`)
};

const de_team_invite_failed = /** @type {(inputs: Team_Invite_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Senden der Einladung.`)
};

const id_team_invite_failed = /** @type {(inputs: Team_Invite_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal mengirim undangan.`)
};

/** @type {(inputs: Team_Invite_FailedInputs) => LocalizedString} */
const ja_team_invite_failed = en_team_invite_failed;

/** @type {(inputs: Team_Invite_FailedInputs) => LocalizedString} */
const zh_team_invite_failed = en_team_invite_failed;

/** @type {(inputs: Team_Invite_FailedInputs) => LocalizedString} */
const ar_team_invite_failed = en_team_invite_failed;

/** @type {(inputs: Team_Invite_FailedInputs) => LocalizedString} */
const it_team_invite_failed = en_team_invite_failed;

/** @type {(inputs: Team_Invite_FailedInputs) => LocalizedString} */
const ru_team_invite_failed = en_team_invite_failed;

/** @type {(inputs: Team_Invite_FailedInputs) => LocalizedString} */
const pt_team_invite_failed = en_team_invite_failed;

/** @type {(inputs: Team_Invite_FailedInputs) => LocalizedString} */
const ko_team_invite_failed = en_team_invite_failed;

/**
* | output |
* | --- |
* | "Failed to send invite." |
*
* @param {Team_Invite_FailedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const team_invite_failed = /** @type {((inputs?: Team_Invite_FailedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Invite_FailedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_team_invite_failed(inputs)
	if (locale === "es") return es_team_invite_failed(inputs)
	if (locale === "fr") return fr_team_invite_failed(inputs)
	if (locale === "de") return de_team_invite_failed(inputs)
	if (locale === "ja") return ja_team_invite_failed(inputs)
	if (locale === "zh") return zh_team_invite_failed(inputs)
	if (locale === "ar") return ar_team_invite_failed(inputs)
	if (locale === "id") return id_team_invite_failed(inputs)
	if (locale === "it") return it_team_invite_failed(inputs)
	if (locale === "ru") return ru_team_invite_failed(inputs)
	if (locale === "pt") return pt_team_invite_failed(inputs)
	return ko_team_invite_failed(inputs)
});